export default __webpack_public_path__ + "static/media/cam2 copy.bdccecab.png";